<div class="mt-1 mb-2">
    <div class="text-center">
        By continuing to use FBOLinx you are consenting to the
        <a href="{{data.eulaDocument?.document}}" target="_blank">Terms</a> and our
        <a href="https://www.iubenda.com/privacy-policy/15357855" target="_blank">Privacy Policy</a> and
        <a href="https://www.iubenda.com/privacy-policy/15357855/cookie-policy" target="_blank">Cookie Policy</a>.
    </div>
</div>

<div>
    <button (click)="decline()" mat-stroked-button>
        Decline
    </button>
    <button
        (click)="accept()"
        class="mr-1"
        color="accent"
        mat-raised-button
    >
        Accept
    </button>
</div>
